module.exports = __webpack_public_path__ + "img/moderator.53262343.svg";